import { Col, Container } from "react-bootstrap";

import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import useSortableData from "../useSortableData";
import Break from "../Breaks/Break";
import { useEffect, useState } from "react";
import BreaksHeader from "../Breaks/BreaksHeader";

export default function TopFlopBreaks({ data, loading, error, dataPath }) {
    const [breaksData, setBreaksData] = useState(null);

    useEffect(() => {
        if (data && data[dataPath]) {
            setBreaksData({ ...data, breaks: data[dataPath] });
        }
    }, [data, dataPath]);

    const { sortedItems, requestSort, sortConfig } = useSortableData(breaksData?.breaks);

    return (
        <div>
            {loading ? (
                <LoadingIndicator width={75} />
            ) : error ? (
                <ErrorResponse errorCode={error} />
            ) : (
                data &&
                data[dataPath] && (
                    <Col>
                        <BreaksHeader dataType={data.data_type} sortConfig={sortConfig} requestSort={requestSort} />
                        <Container fluid>
                            {sortedItems?.map(x => (
                                <Break
                                    key={x.break_id}
                                    radioId={data.radio_id}
                                    dataType={data.data_type}
                                    item={x}
                                    setBreaksData={setBreaksData}
                                    breaksDataPath={dataPath}
                                />
                            ))}
                        </Container>
                    </Col>
                )
            )}
        </div>
    );
}
